import styled from 'styled-components';
import { mediaQueryMobileMin, mediaQueryDesktopMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x5p6fx-0"
})(["align-items:flex-start;display:flex;flex-flow:row wrap;margin:0 -16px;padding:16px 0;width:calc(100% + 32px);@media ", "{margin:0;width:100%;}@media ", "{width:1100px;padding:24px 0;}"], mediaQueryMobileMin, mediaQueryDesktopMin);
export default Wrapper;